// extracted by mini-css-extract-plugin
module.exports = {"headline":"_2oea-","time-ago":"tow8U","wrapper":"_2Ga-T"};